import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import '../../../styles/medics.scss';
import Input from '../../../components/elements/input/Input';
import Select from '../../../components/elements/select/Select';
import DoctorReferralSection from '../../../components/doctor/DoctorReferralSection';
import { fetchAllClinics, fetchMedic } from '../../../api/medics-api';
import { editDoctor } from '../../../api/user-api';
import { toast, ToastContainer } from 'react-toastify';
import { Alert, Button } from 'antd';
import ContentLayout from '../../../layout/ContentLayout';
import { all } from 'axios';

const EditMedic = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const { id } = params;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);

  const toogleShowPassword = () => {
    setPasswordVisible(!passwordVisible);
  };
  console.log('passwordVisible', passwordVisible);

  const [data, setData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    referralCode: '',
    clinic: null,
    password: '',
    referredByDoctor: null,
  });
  const [newReferredByDoctor, setNewReferredByDoctor] = useState(null);
  const [dataFormErrors, setDataFormErrors] = useState({
    firstName: false,
    lastName: false,
    email: false,
    password: false,
  });

  const [allClinics, setAllClinics] = useState([]);

  const handleFetchClinics = async () => {
    const { data, success, message } = await fetchAllClinics();

    if (!success) {
      toast.error(message || 'Error while fetching the data!');
      return;
    }
    console.log('clinics data', data);

    const payload_data =
      data && data.clinics && data.clinics.length > 0
        ? data.clinics.map((i) => {
            return {
              label: i.name,
              value: i,
            };
          })
        : [];

    const array_data = [{ label: 'Select', value: null }, ...payload_data];

    setAllClinics(array_data);
  };

  const getClinicObject = (clinicId) => {
    const clinic = allClinics.find(
      (item) => item.value && item.value._id === clinicId
    );
    return clinic ? clinic.value : null;
  };

  const handleFetchUser = async () => {
    const { data, success, message } = await fetchMedic(id);

    if (!success) {
      toast.error(message || 'Error while fetching the data!');
      return;
    }

    const clinicObject = getClinicObject(data.clinic);

    setData({
      _id: data._id,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      referralCode: data.referralCode || '',
      clinic: clinicObject,
      referredByDoctor: data.referredByDoctor || null,
    });
  };
  console.log('data in edit medic', data);

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSelectClinic = (item) => {
    setData((prev) => {
      return {
        ...prev,
        clinic: item,
      };
    });
  };

  const validateInputs = () => {
    const { firstName, lastName, email, password } = data;
    if (!firstName.trim()) {
      setError('Unesite ime mentora.');
      return false;
    }
    if (!lastName.trim()) {
      setError('Unesite prezime mentora.');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Unesite validnu adresu e-pošte.');
      return false;
    }
    // password to contain at least one uppercase, one lowercase, one number and one special character
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!$%_.,#+])[A-Za-z\d!$%_.,#+]{8,}$/;
    if (passwordVisible && !passwordRegex.test(password)) {
      setError(
        'Lozinka mora sadržati najmanje 8 karaktera, uključujući veliko i malo slovo, broj i specijalni karakter (!$%_.,#+).'
      );
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);

    const isValid = validateInputs();
    if (!isValid) {
      setLoading(false);
      return;
    }

    toast.loading('Ažuriranje podataka...');

    // add password to payload only if it's visible (meaning user wants to change it)
    const payload = passwordVisible
      ? {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          referralCode: data.referralCode,
          clinic: data?.clinic?._id,
          newPassword: data.password,
        }
      : {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          referralCode: data.referralCode,
          clinic: data?.clinic?._id,
        };

    // referredByDoctor is set-once — only include it while it was still empty and
    // admin just picked a referring doctor; the backend ignores it otherwise anyway.
    if (!data.referredByDoctor && newReferredByDoctor) {
      payload.referredByDoctor = newReferredByDoctor;
    }

    try {
      const response = await editDoctor({
        id,
        payload,
      });

      if (!response.success) {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        toast.dismiss();
        toast.error('Došlo je do greške pri ažuriranju podataka.');
        return;
      }
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      toast.dismiss();
      toast.success('Podaci uspešno ažurirani.');
    } catch (error) {
      console.error('Error updating medic:', error);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      toast.dismiss();
      toast.error('Došlo je do greške pri ažuriranju podataka.');
    }
  };

  useEffect(() => {
    if (id) {
      handleFetchUser();
    }
  }, [id, allClinics]);

  useEffect(() => {
    handleFetchClinics();
  }, []);
  console.log('data for edit', data);

  return (
    <ContentLayout>
      <div className="edit_medic_wrapper">
        <div className="edit_medic_container">
          <div className="edit_medic_header">
            <Link to={'/korisnici?tab=mentori'} className="link_btn" style={{ marginLeft: 0 }}>
              <img alt="back image" src="/assets/icons/chevron.svg" />
              <span>Nazad</span>
            </Link>
          </div>

          <div className="edit_medic_form_container">
            <div className="edit_medic_form_wrapper">
              <div className="form_header">
                <span className="form_title">Uredi nalog mentora</span>
              </div>

              <form className="edit_medic_form">
                <div className="grid_row">
                  <div className="cell">
                    <span className="label">Ime</span>
                    <Input
                      onChange={(e) => handleOnChange(e)}
                      name="firstName"
                      id="firstName"
                      value={data.firstName}
                      placeholder="Ime"
                    />
                  </div>

                  <div className="cell">
                    <span className="label">Prezime</span>
                    <Input
                      onChange={(e) => handleOnChange(e)}
                      name="lastName"
                      id="lastName"
                      value={data.lastName}
                      placeholder="Prezime"
                    />
                  </div>

                  <div className="cell">
                    <span className="label">Email</span>
                    <Input
                      onChange={(e) => handleOnChange(e)}
                      name="email"
                      id="email"
                      value={data.email}
                      placeholder="Email"
                    />
                  </div>

                  <div className="cell">
                    <span className="label">Referral kod</span>
                    <Input
                      onChange={(e) => handleOnChange(e)}
                      name="referralCode"
                      id="referralCode"
                      value={data.referralCode}
                      placeholder="Referral kod"
                    />
                  </div>

                  <div className="cell">
                    <span className="label">Organizacija</span>
                    <Select
                      value={{
                        label: data?.clinic?.name || null,
                        value: data?.clinic,
                      }}
                      onChange={handleSelectClinic}
                      items={allClinics}
                      placeholder="Organizacija"
                    />
                  </div>
                  <div className="cell">
                    {passwordVisible ? (
                      <>
                        <span className="label">Lozinka</span>

                        <Input
                          onChange={(e) => handleOnChange(e)}
                          name="password"
                          id="password"
                          value={data.password || ''}
                          placeholder="*******"
                          type="password"
                        />
                      </>
                    ) : (
                      <span className="value">*******</span>
                    )}
                  </div>
                  <div className="cell">
                    <div className="reset_password_wrapper">
                      <button
                        type="button"
                        className="link_btn"
                        style={{ marginLeft: 0 }}
                        onClick={toogleShowPassword}
                      >
                        <span>Resetuj lozinku</span>
                      </button>
                    </div>
                  </div>
                </div>

                {data._id && (
                  <DoctorReferralSection
                    doctor={data}
                    mode="admin"
                    onReferredByDoctorChange={(newId) =>
                      setNewReferredByDoctor(newId)
                    }
                  />
                )}

                {/* <div className="row">
                  <div className="reset_password_wrapper">
                    <button
                      type="button"
                      className="link_btn"
                      style={{ marginLeft: 0 }}
                    >
                      <span>Resetuj lozinku</span>
                    </button>
                  </div>
                  <div className="password_wrapper">
                  <span className="label">Lozinka</span>
                  <span className="value">******</span>
                </div>

                <div className="reset_password_wrapper">
                  <button type="button" className="link_btn">
                    <span>Resetuj lozinku</span>
                  </button>
                </div>
                </div> */}
                {error && (
                  <Alert
                    message={error}
                    type="error"
                    showIcon
                    style={{ marginBottom: 16 }}
                  />
                )}

                <div className="row">
                  <div className="submit_wrapper">
                    <Button
                      className="primary_btn"
                      type="button"
                      onClick={() => handleSubmit()}
                      disabled={loading}
                    >
                      <span>
                        {loading ? 'Učitavanje...' : 'Sačuvaj izmene'}
                      </span>
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* <ToastContainer position="bottom-right" /> */}
      </div>
    </ContentLayout>
  );
};

export default EditMedic;
